<template>
	<div class="resureDialog">
		<el-dialog title="请确认批量发送邮件" width="90%" :visible.sync="dialogTableVisible" top="5vh" @close="hide()">
			<el-table
				ref="multipleTable"
				:data="tableData"
				border
				style="width: 100%; height: 66vh; overflow-y: scroll;"
				@selection-change="selectionChange"
			>
				<el-table-column label="序号" type="index" :index="indexMethod" width="50" align="center" />
				<el-table-column type="selection" width="60" align="center" />
				<el-table-column label="事件id" align="center" prop="caseId" width="150" />
				<el-table-column width="180" align="center" prop="createTime" label="报案日期" />
				<el-table-column align="center" prop="recRealName" label="受助人姓名" show-overflow-tooltip />
				<el-table-column align="center" prop="productName" label="所属计划" show-overflow-tooltip />
				<el-table-column align="center" prop="caseParentFlowName" label="事件状态" show-overflow-tooltip />
				<el-table-column align="center" prop="caseFlowName" label="当前处理状态" show-overflow-tooltip />
				<el-table-column align="center" prop="currentOperatorName" label="当前处理账号" show-overflow-tooltip />
				<el-table-column align="center" prop="endOperatorName" label="最后处理账号" show-overflow-tooltip />
				<el-table-column
					align="center"
					prop="adjustingUploadResultStatus"
					label="是否已完成公估回访"
					show-overflow-tooltip
					width="100"
				/>
				<el-table-column
					align="center"
					prop="customerComplaint"
					label="是否已完成客诉子任务"
					show-overflow-tooltip
					width="100"
				/>
				<el-table-column
					align="center"
					prop="feeCheckStatus"
					label="是否已完成去调查子任务"
					show-overflow-tooltip
					width="110"
				/>
				<el-table-column
					align="center"
					prop="companyAdjustingStatus"
					label="是否已完成公估子任务"
					show-overflow-tooltip
					width="100"
				/>
			</el-table>

			<ul class="select-option flex">
				<li>
					<el-button
						v-if="checkPermission('导出', permList)"
						type="primary"
						:disabled="!selectRows.length"
						icon="iconfont icon-daochu"
						@click="exportCase"
					>
						导出
					</el-button>
				</li>
				<li>
					<el-button
						v-if="checkPermission('业管:批量发送邮件', permList)"
						type="primary"
						icon="el-icon-s-promotion"
						:loading="loadingBtn"
						:disabled="!selectRows.length"
						@click="onSendMail"
					>
						一键发送邮件
					</el-button>
				</li>
			</ul>
		</el-dialog>
		<div v-if="showSchedule" class="schedule-blick flex">
			<el-progress type="circle" :width="200" :percentage="percentage" :color="customColorMethod" />
			<p v-if="percentage != 100" class="schedule-txt flex">
				<i class="el-icon-loading icons" />
				邮件正在发送中，请耐心等待……
			</p>
			<p v-else class="schedule-txt flex on">
				<i class="el-icon-success icons" />
				相关邮件已发送成功
			</p>
		</div>
	</div>
</template>
<script>
import { mapState } from "vuex";
export default {
	props: {
		data: Array,
		params: Object,
	},

	watch: {
		data: {
			handler(val) {
				this.tableData = val;
			},
			immediate: true,
		},
		params: {
			handler(val) {
				this.tableParams = val;
			},
			immediate: true,
		},
	},

	data() {
		return {
			loadingBtn: false,
			dialogTableVisible: false,
			tableData: [],
			selectRows: [],
			taskId: "",
			showSchedule: false,
			percentage: 0,
			tableParams: {},
			isSendEmailSuccess: false,
		};
	},
	computed: {
		...mapState({
			permList: (state) => state.permission.permList,
		}),

		caseIds() {
			return this.selectRows.map((item) => item.caseId).join(",");
		},
	},

	methods: {
		show() {
			this.dialogTableVisible = true;
			this.isSendEmailSuccess = false;
		},
		hide() {
			if (this.isSendEmailSuccess) {
				this.$emit("toRefreshListData");
			}
			this.dialogTableVisible = false;
		},

		indexMethod(index) {
			return index + 1;
		},

		selectionChange(rows) {
			this.selectRows = rows;
		},

		/**
		 * 一键发送邮件
		 */
		onSendMail() {
			this.$confirm("确认一键发送邮件吗?", "温馨提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "success",
			})
				.then(() => {
					this.fetchTaskAdd();
				})
				.catch(() => {});
		},

		/**
		 * 添加批量发送业管邮件任务
		 */
		async fetchTaskAdd() {
			const payloadList = this.selectRows.map((item) => item.caseCode);
			const payload = payloadList.join(",");
			this.loadingBtn = true;
			const res = await this.axios.post(`${this.homePath()}/async-task/add`, {
				type: 1,
				payload,
			});
			const result = res.data;
			if (result.status === "000000") {
				this.taskId = result.data;
				this.percentage = 0;
				await this.$nextTick();
				this.showSchedule = true;
				this.fetchCheckTaskStatus(result.data);
			} else {
				this.loadingBtn = false;
				this.$alert(result.message || "服务器繁忙，请稍后重试", "提示");
			}
		},

		/**
		 * 查询任务执行情况
		 * @param {string} taskId 任务id
		 */
		async fetchCheckTaskStatus(taskId) {
			const { data: result } = await this.axios.get(`${this.homePath()}/async-task/check/${taskId}`);

			if (result.status === "000000") {
				const taskStatus = Number(result.data.status);
				let percentage = 0;
				// 任务状态：0-进行中 1-已完成 2-失败
				switch (taskStatus) {
					case 0:
						percentage = ((result.data.finish / result.data.sum) * 100).toFixed(2);
						this.percentage = parseFloat(percentage);
						await new Promise((resolve) => setTimeout(resolve, 1000));
						await this.fetchCheckTaskStatus(result.data.taskId);
						break;
					case 1:
						this.onTaskCompletion();
						break;
					case 2:
						this.onTaskFail();
						break;
				}
			} else {
				this.$alert(result.message || "服务器繁忙，请稍后重试", "提示");
			}
		},

		/**
		 * 发送邮件-任务完成
		 */
		onTaskCompletion() {
			this.percentage = 100;
			this.isSendEmailSuccess = true;
			this.loadingBtn = false;
			setTimeout(() => {
				this.showSchedule = false;
				this.$notify({
					title: "成功",
					message: "相关邮件已发送成功！",
					type: "success",
				});
			}, 1000);
		},

		/**
		 * 发送邮件-任务失败
		 */
		onTaskFail() {
			this.percentage = 100;
			setTimeout(() => {
				this.showSchedule = false;
				this.$alert("一键发送邮件失败", "温馨提示", {
					confirmButtonText: "确定",
					type: "error",
					callback: () => {
						this.loadingBtn = false;
						this.hide();
					},
				});
			}, 1000);
		},

		/**
		 * 自定义进度条的颜色
		 * @param {number} percentage 进度值
		 */
		customColorMethod(percentage) {
			if (percentage < 30) {
				return "#909399";
			} else if (percentage < 70) {
				return "#e6a23c";
			} else {
				return "#67c23a";
			}
		},

		exportCase() {
			window.location.href =
				this.homePath() +
				"/report/cases-excel-export?accidentType=" +
				(this.tableParams.accidentType == null ? "" : this.tableParams.accidentType) +
				"&applicantName=" +
				(this.tableParams.applicantName == null ? "" : this.tableParams.applicantName) +
				"&caseId=" +
				(this.tableParams.caseId == null ? "" : this.tableParams.caseId) +
				"&createTime=" +
				(this.tableParams.createTime == null ? "" : this.tableParams.createTime) +
				"&flowCode=" +
				(this.tableParams.flowCode == null ? "" : this.tableParams.flowCode) +
				"&limit=100000" +
				"&page=1" +
				"&currentProcessAccount=" +
				(this.tableParams.currentProcessAccount == null ? "" : this.tableParams.currentProcessAccount) +
				"&recRealName=" +
				(this.tableParams.recRealName == null ? "" : this.tableParams.recRealName) +
				"&accessRole=" +
				this.tableParams.accessRole +
				"&caseIds=" +
				this.caseIds +
				"&time=" +
				new Date().valueOf();
		},
	},
};
</script>
<style lang="scss" scoped>
.flex {
	display: flex;
	display: -webkit-flex;
	align-items: center;
}
.select-option {
	overflow: hidden;
	flex-wrap: wrap;
	margin-top: 20px;
	justify-content: flex-end;
	li {
		float: none;
		margin: 0 15px 10px 0;
	}
}

.schedule-blick {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 9999;
	flex-direction: column;
	justify-content: center;
	background-color: rgba(255, 255, 255, 0.9);
	.schedule-txt {
		color: #606266;
		font-size: 14px;
		margin-top: 20px;
		.icons {
			font-size: 20px;
			margin-right: 10px;
		}
		&.on {
			color: #67c23a;
		}
	}
}
</style>
